import { createAuthClient } from 'better-auth/client';
import { emailOTPClient, inferAdditionalFields, twoFactorClient } from 'better-auth/client/plugins';

/**
 * Typed Better Auth client for /api/auth/* (those routes are a catch-all on the server, so the hc
 * client cannot type them). `role` mirrors `user.additionalFields.role` in apps/api/src/lib/auth.ts.
 *
 * `baseUrl` may be '' to use same-origin relative URLs (the Vite dev proxy case).
 * Cookies are always sent: sessions live in an HTTP-only cookie on the API origin.
 */
export const createAuthApiClient = (baseUrl: string) =>
  createAuthClient({
    ...(baseUrl ? { baseURL: baseUrl } : {}),
    fetchOptions: { credentials: 'include' },
    plugins: [
      emailOTPClient(),
      twoFactorClient(),
      // Mirror of user.additionalFields.role on the server (required: false, input: false): the client can read it
      // from the session but never sends it - role is not settable at sign-up.
      inferAdditionalFields({ user: { role: { type: 'string', required: false, input: false } } }),
    ],
  });

export type AuthApiClient = ReturnType<typeof createAuthApiClient>;
